import type { UrlObject } from 'url';
import type { MenuItemProps } from 'types/menu';

export const pathMatch = (currentPath: string, menuItem: MenuItemProps): boolean => {
  if (menuItem.type === 'link' || menuItem.type === 'space' || menuItem.type === 'content') {
    return false;
  }

  const path = menuItem.url ? new URL(menuItem.url).pathname : '';

  return path.replace(/\//g, '') === currentPath.replace(/\//g, '');
};

export const linkUrl = (link: string | UrlObject, isPlattform?: boolean, isVideo?: boolean): string => {
  let url;
  if (typeof link === 'string') {
    if (!link.startsWith('http')) {
      return link + (isVideo ? '?video.autoplay' : '');
    }
    url = new URL(link);
  } else {
    url = link;
  }

  if (url && (isPlattform || url.host === 'www.rtl.de')) {
    return `${url.pathname ?? ''}${url.search ?? ''}${url.hash ?? ''}`;
  }

  return url ? url.toString() : '';
};

export const getLinkPathname = (url: string): string => {
  if (!url) {
    return '';
  }

  return new URL(url).pathname;
};

export const addQueryString = (url: string, query: string) => {
  if (url.includes('?')) {
    return `${url}&${query}`;
  } else {
    return `${url}?${query}`;
  }
};
